<template>
  <div class="loading" v-show="loading">
    <div class="spinner">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="spinner-text">로딩 중 입니다.</div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  z-index: 100004;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}

.spinner {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  top: 47%;
  left: 47%;
  &-text {
    position: absolute;
    top: 58%;
    left: 46%;
    color: $second-background;
  }

  div {
    display: inline-block;
    position: absolute;
    left: 6px;
    width: 13px;
    background: $primary-color;
    animation: spinner 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;

    &:nth-child(1) {
      left: 6px;
      animation-delay: -0.24s;
    }

    &:nth-child(2) {
      left: 26px;
      animation-delay: -0.12s;
    }

    &:nth-child(3) {
      left: 45px;
      animation-delay: 0;
    }

    @keyframes spinner {
      0% {
        top: 6px;
        height: 51px;
      }

      50%,
      100% {
        top: 19px;
        height: 26px;
      }
    }
  }
}
</style>
